<template>
	<div>
		<div class="main-filter">
			<el-form inline :model="formInline" class="demo-form-inline">
				<el-form-item label="讲堂名称：">
					<el-autocomplete
						v-model.trim="formInline.name"
						:fetch-suggestions="querySearchAsync"
						clearable
						placeholder="请输入内容"
						@select="handleSelect"
					></el-autocomplete>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
				<el-button type="primary" @click="modifyParkInfo($event, false)" icon="el-icon-plus">新增</el-button>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:operation-column-width="140"
				:is-show-selection="false"
				:showOperation="true"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<!-- 插槽操作栏固定属性operation -->
				<template #enabled="{ scope }">
					<el-switch inactive-text="否" active-text="是" v-model="scope.row.enabled" @change="changeOpen(scope.row)"> </el-switch>
				</template>
				<template #teacher="{ scope }">
					<el-button @click="showBasicInfo(scope.row, 1)" size="mini" type="text">
						查看({{ scope.row.teachers && scope.row.teachers.length }})
					</el-button>
				</template>
				<template #traningInfo="{ scope }">
					<el-button @click="showBasicInfo(scope.row, 2)" size="mini" type="text"> 添加培训({{ scope.row.trainingCount }})</el-button>
				</template>
				<template #courseInfo="{ scope }">
					<el-button @click="showBasicInfo(scope.row, 3)" size="mini" type="text"> 添加课程({{ scope.row.lessonCount }}) </el-button>
				</template>
				<template #operation="{ scope }">
					<el-button @click="modifyParkInfo($event, true, scope.row)" size="mini" type="primary"> 查看 </el-button>
					<el-button
						@click="modifyParkInfo($event, false, scope.row)"
						size="mini"
						:type="scope.row.enabled ? 'info' : 'warning'"
						:disabled="scope.row.enabled"
					>
						修改
					</el-button>
				</template>
			</Table>
		</div>
		<createView ref="createView" :isShowDetail="isShowDetail" @getList="getList"></createView>
		<ShowList ref="showList"></ShowList>
	</div>
</template>

<script>
export default {
	name: 'teacherManager',
	components: {
		Table: () => import('@/components/Table/table'),
		createView: () => import('./newDialog.vue'),
		ShowList: () => import('./showTeacherList.vue'),
	},
	data() {
		return {
			formInline: {
				name: '',
			},
			tableHead: [
				{
					label: '讲堂编号',
					prop: 'serialNumber',
					formatter: (row) => {
						return row.serialNumber || '-';
					},
				},
				{
					label: '讲堂名称',
					prop: 'title',
					formatter: (row) => {
						return row.title || '-';
					},
				},
				{
					label: '讲堂类别',
					prop: 'lectureTypeDictionaryItem',
					formatter: (row) => {
						return row.lectureTypeDictionaryItem?.title || '-';
					},
				},
				{
					label: '名师',
					prop: 'teacher',
				},
				{
					label: '培训信息',
					prop: 'traningInfo',
				},
				{
					label: '课程信息',
					prop: 'courseInfo',
				},
				{
					label: '创建时间',
					prop: 'createTime',
					formatter: (row) => {
						return row.createTime || '-';
					},
				},
				{
					label: '是否启用',
					prop: 'enabled',
					width: 110,
				},
			],
			loading: false,
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			tableData: [],
			options: [],
			isShowDetail: false,
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 查询条件
		onSearch() {
			this.queryData.current = 1;
			this.getList();
		},
		handleSelect(subInput) {
			this.formInline.name = subInput.name;
		},
		changeOpen(row) {
			this.$http
				.put(this.api.getFamousTeacherLectures + `/${row.id}.json`, row)
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success('操作成功');
						this.getList();
					}
				})
				.catch((e) => {});
		},
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		//获取列表
		getList(type) {
			type == 'filter' ? '' : (this.loading = true);
			let data = {
				...this.formInline,
				...this.queryData,
			};
			this.$http
				.get(this.api.getFamousTeacherLectures + '.json', { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: item.name,
								};
							});
						} else {
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.loading = false;
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		modifyParkInfo(event, isShowDetail, row) {
			let data = {
				row: row || null,
			};
			this.$refs.createView.init(data);
			this.isShowDetail = isShowDetail;
		},
		showBasicInfo(row, type) {
			if (type == 1) {
				this.$refs.showList.showVisible = true;
				this.$refs.showList.tableData = row.teachers || [];
				return;
			} else {
				this.$router.push({
					path: '/teacherHall/hallManager/uploadMaterial',
					query: {
						type: type,
						id: row.id,
						title: row.title,
						hallType: row.lectureTypeDictionaryItem?.title,
						serialNumber: row.serialNumber,
					},
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
	/deep/ .el-select {
		width: 120px !important;
		.el-input {
			width: 120px !important;
			.el-input__inner {
				width: 120px !important;
			}
		}
	}
	/deep/ .el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		.el-button {
			line-height: 32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
	.imgsClass {
		img {
			width: 60px;
			height: 60px;
		}
	}
}
</style>